<i18n src="./resources/locales.json"></i18n>

<template>
  <ecs-login-open-id />
</template>

<script>
import EcsLoginOpenId from '@/components/ecs-login-openid/EcsLoginOpenId';

export default {
  name: 'EcsMSTeamsPage',

  components: { EcsLoginOpenId },

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {}
};
</script>
